{{#if details}}
    {{{details.details}}}
{{else}}
    {{{summary}}}
{{/if}}
